'use client';

import { c as _c } from "react/compiler-runtime";
import { MODAL_HEADER_INSET_RESET } from '@components/modal/ModalHeaderRow';
import { IconClose } from '@endurancewarranty/icons';
import { cx, DialogOverlay } from '@endurancewarranty/ui';
import { INITIAL_SIDEBAR_DIALOG_STATE, sidebarDialogAtom } from '@lib/states/dialogs/sidebarDialogAtom';
import { useJotaiAtom } from '@states/jotai/hooks';
import type { FC } from 'react';
export const SidebarDialog: FC = () => {
  const $ = _c(19);
  const [sidebarDialogState, setSidebarDialogState] = useJotaiAtom(sidebarDialogAtom);
  const {
    isOpen,
    size: t0,
    children,
    openDirection: t1,
    hasCloseButton: t2
  } = sidebarDialogState;
  const size = t0 === undefined ? "sm" : t0;
  const openDirection = t1 === undefined ? "right" : t1;
  const hasCloseButton = t2 === undefined ? true : t2;
  const t3 = openDirection === "right";
  const t4 = openDirection === "left";
  const t5 = openDirection === "center";
  let t6;
  if ($[0] !== openDirection || $[1] !== size || $[2] !== t3 || $[3] !== t4 || $[4] !== t5) {
    t6 = cx("h-full absolute", {
      "right-0": t3,
      "left-0": t4,
      "left-1/2 top-1/2 transform -translate-x-1/2 -translate-y-1/2": t5
    }, {
      "w-[1200px]": size === "xl",
      "w-[875px]": size === "lg",
      "w-[700px]": size === "md",
      "w-[525px]": size === "sm"
    }, "pt-24 pb-4", {
      "pr-4": openDirection === "right",
      "pl-4": openDirection === "left"
    });
    $[0] = openDirection;
    $[1] = size;
    $[2] = t3;
    $[3] = t4;
    $[4] = t5;
    $[5] = t6;
  } else {
    t6 = $[5];
  }
  const containerStyle = t6;
  if (!isOpen) {
    return null;
  }
  const t7 = !hasCloseButton;
  let t8;
  if ($[6] !== t7) {
    t8 = cx("bg-background-0 h-full", {
      [MODAL_HEADER_INSET_RESET]: t7
    });
    $[6] = t7;
    $[7] = t8;
  } else {
    t8 = $[7];
  }
  const t9 = hasCloseButton ? _temp : undefined;
  let t10;
  if ($[8] !== setSidebarDialogState) {
    t10 = () => setSidebarDialogState(INITIAL_SIDEBAR_DIALOG_STATE);
    $[8] = setSidebarDialogState;
    $[9] = t10;
  } else {
    t10 = $[9];
  }
  let t11;
  if ($[10] !== children || $[11] !== containerStyle || $[12] !== hasCloseButton || $[13] !== isOpen || $[14] !== sidebarDialogState.shouldCloseOnBlur || $[15] !== t10 || $[16] !== t8 || $[17] !== t9) {
    t11 = <DialogOverlay containerClassName={containerStyle} className={t8} hasCloseButton={hasCloseButton} renderCloseButton={t9} isOpen={isOpen} onClose={t10} shouldCloseOnBlur={sidebarDialogState.shouldCloseOnBlur}>{children}</DialogOverlay>;
    $[10] = children;
    $[11] = containerStyle;
    $[12] = hasCloseButton;
    $[13] = isOpen;
    $[14] = sidebarDialogState.shouldCloseOnBlur;
    $[15] = t10;
    $[16] = t8;
    $[17] = t9;
    $[18] = t11;
  } else {
    t11 = $[18];
  }
  return t11;
};
function _temp(onClose) {
  return <button type="button" aria-label="Close" onClick={onClose} className="border-bcolor-active text-text-color-500 hover:border-bcolor-focused absolute top-4 right-4 z-10 flex h-10 w-10 items-center justify-center rounded-full border"><IconClose width={14} /></button>;
}